import React from 'react'
import { withRouter } from 'react-router'
import Sidebar from '../components/layout/sidebar/Sidebar.jsx'
import SendEmail from '../components/sendEmail/SendEmail'

const sendEmail = () => {
    return (
        <div>
            <SendEmail />
            <Sidebar />
        </div>
    )
}

export default withRouter(sendEmail)
